let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("rE0x9")).then(() => parcelRequire('bZPwi'));